export default __webpack_public_path__ + "static/media/hhm-horizlanding.eaaf8055.gif";